class e extends HTMLElement {
  constructor() {
    super(), this.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 16 16"><path d="M8 12v-1a1.648 1.648 0 0 0 1.5-1.5h1A2.633 2.633 0 0 1 8 12Z"></path><path d="M8 14a4.506 4.506 0 0 1-4.5-4.5 4.992 4.992 0 0 1 .747-2.478l3.33-5.304a.52.52 0 0 1 .847 0l3.314 5.279c.47.752.733 1.616.762 2.503A4.506 4.506 0 0 1 8 14ZM8 2.924 5.11 7.528A3.988 3.988 0 0 0 4.5 9.5a3.5 3.5 0 0 0 7 0 4.03 4.03 0 0 0-.624-1.998L8 2.924Z"></path></svg>';
  }
}
const t = "pi-mod-water";
customElements.get(t) || customElements.define(t, e);
export {
  e as default
};
